import React, { useState, useEffect } from 'react';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';

export function useBackboneView(viewFactory, onViewCreated, { managed = false, onViewRemoved, getCreatedView } = {}) {
  const [backboneView, setBackboneView] = useState(null);

  useEffect(() => {
    let view = getCreatedView != null ? getCreatedView() : undefined;
    if (view == null) {
      view = viewFactory();
      onViewCreated(view);
    }
    setBackboneView(view);
    return () => {
      if (onViewRemoved != null) {
        onViewRemoved();
      }
    };
  }, [onViewCreated, viewFactory, onViewRemoved, getCreatedView]);

  if (backboneView) {
    return (<BackboneInstanceWrapper instance={backboneView} managed={managed} />);
  }

  return null;
}
